export default {
  siteTitle: "发行商",
  fetchUrl: "https://api.niucodata.com/release/ant_pro/",
  makeCodeUrl: "https://m.niucodata.com/box_pay/pay_copyright.php?order_id=",
};
